/**
 * Shared storage class.
 *
 * @type {Object}
 */

import Host from './host';
import Guest from './guest';

/**
 * Class SharedStorage
 */
class SharedStorage {

	/**
	 * Constructor.
	 *
	 * @returns
	 */
	constructor() {

		if ( 'undefined' === typeof SharedStorageOptions ) {
			return;
		}

		this.options = SharedStorageOptions;

		if ( ! this.options.type ) {
			return;
		}

		this.environment = this.options.environment;

		this.connect();

	}

	/**
	 * Create connection based on connection type defined.
	 */
	connect() {

		if ( this.isHost() ) {
			this.connectHost();
		}

		if ( this.isGuest() ) {
			this.connectGuest();
		}

	}

	/**
	 * Connect to the host.
	 */
	connectHost() {

		this.host = new Host( this.options.currentHostName );

		for ( let key in this.options.guests ) {
			let domain = this.options.guests[ key ].domain;

			if ( ! domain || '' === domain ) {
				continue;
			}

			let methods = [];

			this.options.guests[ key ].get && methods.push( 'get' );
			this.options.guests[ key ].set && methods.push( 'set' );
			this.options.guests[ key ].remove && methods.push( 'remove' );

			this.host.addHost( domain, methods );
		}

		this.host.connect();
	}

	/**
	 * Connect to the guest.
	 */
	connectGuest() {

		// Creates a guest pointing to the mentioned host.
		this.guest = new Guest( this.options.host );
	}

	/**
	 * Get storage data.
	 *
	 * @param {*} key
	 * @param {*} callback
	 * @returns
	 */
	get( key, callback ) {

		if ( this.isHost() ) {
			let value = this.host.storage.get( key );
			let error = value ? null : 'Data not found!';
			callback( error, value );

			return;
		}

		this.guest.storage.get( key, callback );

	}

	/**
	 * Set storage data
	 *
	 * @param {*} key
	 * @param {*} data
	 * @param {*} callback
	 * @returns
	 */
	set( key, data, callback ) {

		if ( this.isHost() ) {
			this.host.storage.set( key, data );

			let value = localStorage.getItem( key );
			let error = value ? null : 'Unable to set data!';
			callback( error, value );

			return;
		}

		this.guest.storage.set( key, data, callback );

	}

	/**
	 * Remove data from storage.
	 *
	 * @param {*} key
	 * @param {*} callback
	 * @returns
	 */
	remove( key, callback ) {

		if ( this.isHost() ) {
			localStorage.removeItem( key );

			let value = localStorage.getItem( key );
			let error = value ? 'Unable to remove data!' : null;
			callback( error, value );

			return;
		}

		this.guest.storage.remove( key, callback );

	}

	/**
	 * Is current network host.
	 *
	 * @returns {bool}
	 */
	isHost() {
		return 'host' === this.options.type;
	}

	/**
	 * Is current network guest.
	 *
	 * @returns {bool}
	 */
	isGuest() {
		return 'guest' === this.options.type;
	}

};

export default SharedStorage;
